import AgreeBlock from './AgreeBlock';

export default AgreeBlock;
